module.exports = __webpack_public_path__ + "img/plumbingcad.3e687651.png";